import React, { useEffect } from 'react';
import { scroller } from "react-scroll";
import sanitizeHtml from 'sanitize-html'
import { compileDisclosureFDIC } from '../../utils/SiteTools';
import './Disclosure.scss';

/**
 * This function takes in a disclosure object and returns a link that will scroll to the target element
 */
const Disclosure = ({ disclosures }) => {
	const footNoteEvent = obj => {
		const disclosureTarget = (obj.href).split('#')[1];
		if (document.getElementById(disclosureTarget)) {
			const disclosureTargetTop = document.getElementById(disclosureTarget).offsetTop;
			scroller.scrollTo(disclosureTargetTop, {
				duration: 800,
				delay: 0,
				smooth: "easeInOutQuart",
			});
			document.getElementById(disclosureTarget).focus();
		}
	}

	/* This is a React Hook that will listen for clicks on the page and if the click is on a footnote, it
	will scroll to the target element. */
	useEffect(() => {
		document.addEventListener('click', e => {
			const eleFootnote = e.target.parentNode;
			if (eleFootnote && eleFootnote.classList.contains('footnote')) {
				e.preventDefault();
				footNoteEvent(e.target);
			}
		});
	}, [disclosures]);

	return <div className="disclosure-wrapper container_wrapper">
		{
			disclosures && disclosures.map((item, i) => <div key={i} className="disclosure-item">
				{item.marker !== ' ' ? <div id={`footnote${item.marker}`} className="marker" tabIndex="-1" aria-label={`Footnote ${item.marker}`} dangerouslySetInnerHTML={{ __html: item.marker }} /> : ''}
				<div className="copy" dangerouslySetInnerHTML={{ __html: sanitizeHtml(compileDisclosureFDIC(item.text).join(''), { allowedAttributes: { 'a': ['href', 'aria-label', 'id', 'target'], 'ul': ['class', 'lang'] }} ) }} />
			</div>)
		}
	</div>
}

export default Disclosure;